import React from "react";
import "./App.css";

const SITE_URL = "https://rentaquad.fr";

export default function App() {
  return (
    <div className="WebviewRoot">
      <iframe
        className="WebviewFrame"
        src={SITE_URL}
        title="RentaQuad"
        referrerPolicy="no-referrer-when-downgrade"
        loading="eager"
        allow="fullscreen"
      />

      <div className="WebviewFallback" role="note" aria-label="Fallback">
        <span>
          
        </span>
        <a
          className="WebviewButton"
          href={SITE_URL}
          target="_blank"
          rel="noreferrer"
        >
          Ouvrir dans un nouvel onglet
        </a>
      </div>
    </div>
  );
}
